export default __webpack_public_path__ + "static/media/cross_gray.de974026.svg";